import React from 'react'
import 'react-toastify/dist/ReactToastify.css'

import {AppTheme} from '../types'

import AccountSwitcher from '../containers/AccountSwitcher'
import {sendBackToDashboardPostMessage} from '../utils/common-utils'
import {whitelabelConfig} from "../config";
import {CompanyEnumIndices} from "@bdswiss/common-enums";

export interface Props {
  mode: string
  theme: AppTheme
  demo?: string
  onDeposit: () => void
}

export interface State {
  prevType: number
}
const Header = (props: Props) => {
  return <HeaderContent {...props} />
}

class HeaderContent extends React.Component<Props, State> {
  public componentDidUpdate(nextProps: Props) {
    document.body.classList.toggle('embeddedHeightReduction', nextProps.mode !== 'normal')
  }

  public render() {
    const { mode, demo, theme } = this.props
    const curUrl = document.referrer || window.location.href
    let logo = (
      <img
        src={`/assets/ui/img/logo${theme === 'Dark' ? '-dark' : ''}.svg`}
        className="logo__img"
        alt="Logo"
      />
    )

    switch (whitelabelConfig.whitelabel) {
      case CompanyEnumIndices.skyGround:
        logo = (
          <img
            src={`/assets/ui/img/skyground-${theme === 'Dark' ? 'dark' : 'light'}.svg`}
            className="logo__img-skyground"
            alt="Logo"
          />
        )
        break
      case CompanyEnumIndices.equityFlow:
        logo = (
          <img
            src={`/assets/ui/img/equityflow-${theme === 'Dark' ? 'dark' : 'light'}.png`}
            className="logo__img-equityflow"
            alt="Logo"
          />
        )
        break
      case CompanyEnumIndices.lydian:
        logo = (
          <img
            src={`/assets/ui/img/lydian-${theme === 'Dark' ? 'dark' : 'light'}.svg`}
            className="logo__img-lydian"
            alt="Logo"
          />
        )
        break
      case CompanyEnumIndices.tauroMarkets:
        logo = (
          <img
            src={`/assets/ui/img/tauromarkets-${theme === 'Dark' ? 'dark' : 'light'}.png`}
            className="logo__img-tauromarkets"
            alt="Logo"
          />
        )
        break
      case CompanyEnumIndices.bdSwissMauritius:
        logo = (
          <img
            src={`/assets/ui/img/valutamarkets-${theme === 'Dark' ? 'dark' : 'light'}.png`}
            className="logo__img-valutamarkets"
            alt="Logo"
          />
        )
        break
    }

    return (
      <header className={'header ' + (mode === 'embedded' && demo === 'bonds' ? 'hidden' : '')}>
        <div className="d-flex flex-column flex-md-row align-items-center justify-content-start">
          <div className="logo-wrap">
            <div className="logo" onClick={sendBackToDashboardPostMessage}>
              {logo}
            </div>
          </div>
          <div className="d-flex flex-row justify-content-end align-items-center w-100">
            <AccountSwitcher />
          </div>
        </div>
      </header>
    )
  }
}

export default Header
